import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { log } from '@atlassian/mpac-utils';
import URL from 'url-parse';
import { instanceToModule, returnsPromise } from './connect/Util';
const getUrmCreateUrl = siteBaseUrl => "".concat(siteBaseUrl, "/gateway/api/admin/private/at/v1/request");
let AdminTaskApi = (_class = class AdminTaskApi {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "siteBaseUrl", void 0);
    this.config = config;
    this.siteBaseUrl = new URL(this.config.baseUrl).origin;
  }
  async createUrmRequest(request) {
    const urmRequest = {
      type: 'marketplace-app-request',
      requestedEntity: "ari:cloud:marketplace::app-key/".concat(request.appKey),
      targetEntity: "ari:cloud:platform::site/".concat(request.cloudId),
      metadata: {
        productName: request.productName
      }
    };
    try {
      await fetchOk(getUrmCreateUrl(this.siteBaseUrl), {
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(urmRequest)
      });
    } catch (error) {
      log.error('createUrmRequest', 'Error encountered when creating URM request', {
        error,
        variables: _objectSpread({}, request)
      });

      // Swallow error, don't rethrow so as to not interrupt the user
    }
  }
}, (_applyDecoratedDescriptor(_class.prototype, "createUrmRequest", [returnsPromise], Object.getOwnPropertyDescriptor(_class.prototype, "createUrmRequest"), _class.prototype)), _class);
export default (config => instanceToModule(new AdminTaskApi(config)));